import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  enterTooltip,
  leaveTooltip,
} from '../../store/modules/TooltipManagerActions';
import { getRectCenterPoint } from '../../utils/RectUtils';
import styles from './Tooltip.scss';

const rootClassName = styles.rootClassName;

class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenHeight: window.innerHeight,
      screenWidth: window.innerWidth,
    };
  }

  updateDimensions() {
    this.setState({
      ...this.state,
      screenHeight: window.innerHeight,
      screenWidth: window.innerWidth,
    });
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
    window.addEventListener('scroll', this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
    window.removeEventListener('scroll', this.updateDimensions.bind(this));
  }

  getDirections() {
    const position = getRectCenterPoint(this.props.state.rect);
    const screenWidth = this.state.screenWidth;
    const screenHeight = this.state.screenHeight;
    let directions = [];
    if (
      position.left > screenWidth / 2 - 150 &&
      position.left < screenWidth / 2 + 150
    ) {
      directions.push('center');
    } else {
      if (position.left > screenWidth / 2) {
        directions.push('left');
      } else {
        directions.push('right');
      }
    }
    if (position.top - window.scrollY > screenHeight / 2) {
      directions.push('top');
    } else {
      directions.push('bottom');
    }
    return directions;
  }

  getContainerClasses() {
    let classes = [rootClassName + '-container'];
    if (this.props.state.opened || this.props.state.enter) {
      classes.push(rootClassName + '-container-opened');
    }
    return classes.join(' ');
  }

  getContainerProps() {
    const position = getRectCenterPoint(this.props.state.rect);
    let allProps = {
      className: this.getContainerClasses(),
      style: {
        top: position.top,
        left: position.left,
      },
    };
    return allProps;
  }

  getTooltipClasses() {
    let classes = [
      rootClassName + '-tooltip',
      this.props.state.options && this.props.state.options.tooltipClassName
        ? this.props.state.options.tooltipClassName
        : '',
    ];
    const directions = this.getDirections();
    if (directions) {
      directions.forEach((direction) => {
        classes.push(rootClassName + '-tooltip-' + direction);
        classes.push('tooltip-' + direction);
      });
    }
    if (this.props.state.text.length < 50) {
      classes.push(rootClassName + '-tooltip-long');
    }
    return classes.join(' ');
  }

  onMouseEnter = () => {
    this.props.enterTooltip(this.props.state.key);
  };

  onMouseLeave = () => {
    this.props.leaveTooltip(this.props.state.key);
  };

  render() {
    return (
      <div {...this.getContainerProps()}>
        <div
          className={this.getTooltipClasses()}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          {this.props.state.text}
        </div>
      </div>
    );
  }
}

Tooltip.propTypes = {
  state: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  tooltipManager: state.tooltipManager,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      enterTooltip,
      leaveTooltip,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Tooltip);
